import React from 'react';
import { Text, useToast } from '@chakra-ui/react';
import { localise, templateReplace } from '../../../services/lang/lang';
import { ConfirmationModal } from '../ConfirmationModal/ConfirmationModal';
import { useDeleteRemoteSubmissionInvite } from '../../../services/api/generated/client';
export const DeleteRemoteSubmissionInviteModalWrapper = ({ invite, onMutated, onClose, }) => {
    const toast = useToast();
    const { mutate, isPending, isError, error } = useDeleteRemoteSubmissionInvite();
    const deleteInvite = () => {
        mutate({ id: invite.id }, {
            onSuccess: () => {
                onClose();
                onMutated();
                toast({
                    title: localise('INVITE_REVOKED'),
                    status: 'success',
                    isClosable: true,
                });
            },
        });
    };
    return (React.createElement(ConfirmationModal, { isOpen: true, title: localise('REVOKE_INVITE'), onClose: onClose, onConfirm: deleteInvite, isLoading: isPending, isError: isError, error: error },
        React.createElement(Text, { "data-testid": "revoke-invite-modal-text" },
            templateReplace(localise('REVOKE_INVITE_CONFIRM_QUESTION'), {
                email: invite.contact.email,
            }),
            "?")));
};
